/* Product comparison (floating Compare button + modal). Moved from an inline script in layout/theme.liquid; loaded with defer. */
      (function(){
        // If a page-specific renderer already exists, skip defining globals
        if (typeof window.renderCompare === 'function') return;

        const LOCAL_KEY = 'shopify_compare_products';
        const MAX_COMPARE = 4;

        function getStored(){
          try {
            const raw = localStorage.getItem(LOCAL_KEY);
            return raw ? JSON.parse(raw) : [];
          } catch(_) { return []; }
        }
        function setStored(arr){
          try { localStorage.setItem(LOCAL_KEY, JSON.stringify(arr)); } catch(_) {}
        }
        function removeFromCompare(handle){
          const arr = getStored().filter(item => {
            if (typeof item === 'string') return item !== handle;
            return item && item.handle !== handle;
          });
          setStored(arr);
          return arr;
        }
        async function fetchProduct(handle){
          try {
            const res = await fetch(themeRootPath() + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
            if (!res.ok) throw new Error('Product fetch failed');
            return await res.json();
          } catch(e){
            console.warn('Compare fetch error', e);
            return null;
          }
        }
        function escapeHtml(str){
          const div = document.createElement('div');
          div.textContent = String(str || '');
          return div.innerHTML;
        }
        function formatMoney(cents){
          try {
            const num = Number(cents);
            if (!isFinite(num)) return '';
            return (num / 100).toFixed(2);
          } catch(_) { return ''; }
        }
        function openCompareModal(){
          const modal = document.getElementById('compare-modal');
          if (!modal) return;
          modal.classList.add('show');
          modal.setAttribute('aria-hidden','false');
        }
        function closeCompareModal(){
          const modal = document.getElementById('compare-modal');
          if (!modal) return;
          modal.classList.remove('show');
          modal.setAttribute('aria-hidden','true');
        }

        async function normalizeProducts(raw){
          const products = [];
          for (const item of raw){
            if (!item) continue;
            if (typeof item === 'string') {
              const p = await fetchProduct(item);
              if (p) products.push(p);
            } else if (item && typeof item === 'object') {
              products.push(item);
            }
          }
          return products;
        }

        async function renderCompare(){
          const container = document.getElementById('compare-table-wrap');
          if (!container) return;
          const raw = getStored();

          const countEl = document.getElementById('compare-count');
          if (countEl) countEl.textContent = String(raw.length);
          const btnCount = document.getElementById('compare-button-count');
          if (btnCount) btnCount.textContent = String(raw.length);

          if (!raw.length){
            container.innerHTML = '<p>No products selected for comparison. Click Compare on product cards to add.</p>';
            return;
          }

          const products = await normalizeProducts(raw);
          const currencySymbol = (window.__CURRENCY__ && window.__CURRENCY__.symbol) || '$';

          let html = '<table id="compare-table">';
          html += '<thead><tr><th></th>';
          products.forEach(p => {
            const img = (p.images && p.images[0]) || (p.image || '');
            html += `<th>
              <div class="compare-product-header">
                ${img ? `<img src="${img}" alt="${escapeHtml(p.title || '')}" />` : ''}
                <div>
                  <strong>${escapeHtml(p.title || '')}</strong><br/>
                  <small>${escapeHtml(p.vendor || '')}</small>
                </div>
              </div>
              <div style="margin-top:8px;">
                <button class="compare-remove" data-handle="${p.handle}">${TS('remove', 'Remove')}</button>
              </div>
            </th>`;
          });
          html += '</tr></thead>';

          const baseAttrs = [
            { key: 'title', label: TS('compareProduct', 'Product') },
            { key: 'price', label: TS('comparePrice', 'Price') },
            { key: 'vendor', label: TS('compareVendor', 'Vendor') },
            { key: 'type', label: TS('compareType', 'Type') },
            { key: 'tags', label: TS('compareTags', 'Tags') },
            { key: 'description', label: TS('compareDescription', 'Description') },
            { key: 'add_to_cart', label: TS('addToCartProduct', 'Add to cart') }
          ];

          html += '<tbody>';
          baseAttrs.forEach(attr => {
            html += `<tr data-attr="${attr.key}"><th>${escapeHtml(attr.label)}</th>`;
            products.forEach(p => {
              let cell = '';
              switch(attr.key){
                case 'title':
                  cell = `<a href="${themeRootPath()}products/${encodeURIComponent(p.handle)}">${escapeHtml(p.title || '')}</a>`;
                  break;
                case 'price': {
                  const v0 = (p.variants && p.variants[0]) ? p.variants[0] : null;
                  const cents = v0 && v0.price ? v0.price : (p.price_min || p.price || null);
                  const val = cents != null ? `${currencySymbol}${formatMoney(cents)}` : '';
                  cell = val;
                  break;
                }
                case 'vendor':
                  cell = escapeHtml(p.vendor || '');
                  break;
                case 'type':
                  cell = escapeHtml(p.type || p.product_type || '');
                  break;
                case 'tags':
                  if (Array.isArray(p.tags) && p.tags.length) {
                    const displayTags = p.tags.map(t => escapeHtml(t)).join(', ');
                    cell = `<div class="compare-tags">${displayTags}</div>`;
                  } else {
                    cell = '';
                  }
                  break;
                case 'description':
                cell = escapeHtml(
                    String(p.description || '')
                        .replace(/<[^>]*>/g, '')  // remove all HTML tags
                        .slice(0, 300)
                );
                break;

                case 'add_to_cart': {
                  const vid = (p.variants && p.variants[0] && p.variants[0].id) ? p.variants[0].id : '';
                  cell = vid ? `<button class="add-to-cart-compare common-btn" data-variant-id="${vid}" data-handle="${escapeHtml(p.handle)}">${TS('addToCartProduct', 'Add to cart')}</button>` : '';
                  break;
                }
                default:
                  cell = '';
              }
              html += `<td>${cell}</td>`;
            });
            html += '</tr>';
          });
          html += '</tbody></table>';

          container.innerHTML = html;

          // Bind remove
          container.querySelectorAll('.compare-remove').forEach(btn => {
            btn.addEventListener('click', () => {
              const h = btn.getAttribute('data-handle');
              removeFromCompare(h);
              // Re-render table and update button states across page
              renderCompare();
              // Update both .compare-btn and [data-compare-btn] buttons
              const updateAllButtons = (selector) => {
                document.querySelectorAll(selector).forEach(b => {
                  const handle = b.getAttribute('data-handle') || b.getAttribute('data-product-handle');
                  if (handle) updateCompareButtonState(b, handle);
                });
              };
              updateAllButtons('.compare-btn');
              updateAllButtons('[data-compare-btn]');
              const countEl = document.getElementById('compare-count');
              if (countEl) countEl.textContent = String(getStored().length);
            });
          });

          // Bind add-to-cart
          container.querySelectorAll('.add-to-cart-compare').forEach(btn => {
            btn.addEventListener('click', async (e) => {
              e.preventDefault();
              const id = btn.getAttribute('data-variant-id');
              if (!id) return;
              btn.disabled = true;
              try {
                const res = await fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: Number(id), quantity: 1 })
                });
                if (res.ok) {
                  btn.textContent = TS('added', 'Added');
                  btn.classList.add('added');
                } else {
                  btn.disabled = false;
                }
              } catch(_) {
                btn.disabled = false;
              }
            });
          });
        }

        // Compare button state and attachment
        function updateCompareButtonState(btn, handle) {
          const stored = getStored();
          const isAdded = stored.some(p => (typeof p === 'string' ? p === handle : p && p.handle === handle));
          // Prefer class/aria updates for broader markup compatibility
          btn.classList.toggle('added', isAdded);
          btn.setAttribute('aria-pressed', isAdded ? 'true' : 'false');
          // If a specific label node exists, update it; otherwise fallback to text for .compare-btn
          const labelEl = btn.querySelector('[data-compare-label]');
          if (labelEl) {
            labelEl.textContent = isAdded ? TS('addedToCompare', 'Added to Compare') : TS('compareProductLabel', 'Compare Product');
          } else if (btn.matches('.compare-btn')) {
            btn.textContent = isAdded ? TS('addedToCompare', 'Added to Compare') : TS('compareProductLabel', 'Compare Product');
          }
        }

        async function onCompareClick(btn){
          const handle = btn.getAttribute('data-handle');
          if (!handle) return;
          // Build pre object from data- attributes
          const pre = {
            handle: handle,
            title: btn.getAttribute('data-title') || '',
            vendor: btn.getAttribute('data-vendor') || '',
            tags: (btn.getAttribute('data-tags') || '').split(',').map(t => t.trim()).filter(Boolean),
            extra: {}
          };
          Array.from(btn.attributes).forEach(attr => {
            if (!attr.name.startsWith('data-')) return;
            const key = attr.name.slice(5);
            if (['handle','title','vendor','tags'].includes(key)) return;
            pre.extra[key] = attr.value;
          });
          // Add pre first
          let arr = getStored();
          if (!arr.find(x => (typeof x === 'string' ? x === handle : x && x.handle === handle))) {
            arr.push(pre);
            while (arr.length > MAX_COMPARE) arr.shift();
            setStored(arr);
          }
          // Fetch full product and merge
          try {
            const full = await fetchProduct(handle);
            if (full) {
              const productObj = {
                handle: full.handle,
                title: full.title,
                vendor: full.vendor,
                type: full.type || full.product_type || '',
                images: full.images || [],
                description: full.description || '',
                tags: full.tags || [],
                variants: full.variants || [],
                price: full.price || (full.variants && full.variants[0] && full.variants[0].price) || null,
                price_min: full.price_min || null,
                extra: Object.assign({}, pre.extra)
              };
              let arr2 = getStored().filter(x => (typeof x === 'string' ? x !== handle : x && x.handle !== handle));
              arr2.push(productObj);
              setStored(arr2);
            }
          } catch(_){ /* noop */ }

          // Update UI and open modal
          updateCompareButtonState(btn, handle);
          openCompareModal();
          renderCompare();
          const countEl = document.getElementById('compare-count');
          if (countEl) countEl.textContent = String(getStored().length);
        }

        function attachCompareButtons(root = document){
          const connect = (btn) => {
            if (btn._compareAttached) return;
            const handle = btn.getAttribute('data-handle') || btn.getAttribute('data-product-handle');
            if (handle) updateCompareButtonState(btn, handle);
            btn.addEventListener('click', (e) => {
              e.preventDefault();
              const h = btn.getAttribute('data-handle') || btn.getAttribute('data-product-handle');
              if (!h) return;
              const stored = getStored();
              const already = stored.some(p => (typeof p === 'string' ? p === h : p && p.handle === h));
              if (already) {
                openCompareModal();
                renderCompare();
                return;
              }
              // Ensure data-handle exists for downstream logic
              if (!btn.getAttribute('data-handle')) btn.setAttribute('data-handle', h);
              onCompareClick(btn);
            });
            btn._compareAttached = true;
          };
          root.querySelectorAll('.compare-btn').forEach(connect);
          root.querySelectorAll('[data-compare-btn]').forEach(connect);
        }

        // Initialize compare buttons and modal controls
        function initCompareGlobal(){
          attachCompareButtons(document);
          const observer = new MutationObserver(mutations => {
            for (const m of mutations) {
              if (m.addedNodes && m.addedNodes.length) {
                m.addedNodes.forEach(node => {
                  if (node.nodeType === 1) attachCompareButtons(node);
                });
              }
            }
          });
          observer.observe(document.body, { childList: true, subtree: true });
          // Close controls
          document.querySelectorAll('[data-close]').forEach(el => el.addEventListener('click', closeCompareModal));
          // Floating compare button
          const floatBtn = document.getElementById('compare-floating-btn');
          if (floatBtn && !floatBtn._compareAttached) {
            floatBtn.addEventListener('click', (e) => {
              e.preventDefault();
              openCompareModal();
              renderCompare();
            });
            floatBtn._compareAttached = true;
          }
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', function(){ initCompareGlobal(); });
        } else {
          initCompareGlobal();
        }

        // Expose globally so the floating button can call these
        window.openCompareModal = openCompareModal;
        window.closeCompareModal = closeCompareModal;
        window.renderCompare = function(){ renderCompare(); };
        window.getCompareStored = getStored;
        window.setCompareStored = setStored;
        window.removeFromCompareStored = removeFromCompare;
        window.updateCompareButtonState = updateCompareButtonState;
      })();
